module.exports = __webpack_public_path__ + "media/pages/Home/images/Landing_Product_OnlineRestaurant-1b322ff2c6bf0417ed9ba315bfe946cf.jpg";